import { Component, Input, OnInit } from '@angular/core'
import { GiftPointHistory, targetPeriod } from 'src/lib/entity/gift-point'
import { ConsoleLogger } from 'src/lib/console-logger'

@Component({
  selector: 'maglive-point-manage',
  templateUrl: './point-manage.component.html',
  styleUrls: ['./point-manage.component.scss'],
})
export class PointManageComponent implements OnInit {
  @Input() isShowPointHistoryPage: boolean
  @Input() targetPeriod: targetPeriod[]
  @Input() pointHistories: GiftPointHistory[][] | 'NOT_FOUND'

  months: number[]
  selectedMonth: number
  pointHistoriesForMonth: GiftPointHistory[] | 'NOT_FOUND'

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    this.logger.info(
      this.constructor.name,
      'ngOnInit',
      'pointHistories',
      this.pointHistories
    )
    if (this.pointHistories !== 'NOT_FOUND') {
      this.months = [
        this.targetPeriod[2].month,
        this.targetPeriod[1].month,
        this.targetPeriod[0].month,
      ]
      this.selectedMonth = this.months[2]
      this.pointHistoriesForMonth = this.pointHistories[2]
      if (this.pointHistoriesForMonth.length === 0)
        this.pointHistoriesForMonth = 'NOT_FOUND'
    }
  }

  /**
   * 選択した月に応じて表示するポイント履歴データを変更する
   */
  changeDisplayMonth(month: number) {
    this.selectedMonth = month
    if (this.pointHistories !== 'NOT_FOUND') {
      let index = this.months.findIndex((element) => {
        return element === this.selectedMonth
      })
      if (this.pointHistories[index].length !== 0) {
        this.pointHistoriesForMonth = this.pointHistories[index]
      } else {
        this.pointHistoriesForMonth = 'NOT_FOUND'
      }
    } else {
      this.pointHistoriesForMonth = 'NOT_FOUND'
    }
    this.logger.info(
      this.constructor.name,
      'changeDisplayMonth',
      'pointHistoriesForMonth',
      this.pointHistoriesForMonth
    )
  }
}
